import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export function MessageBox({ message }) {
    return message ? <Box>
        <Typography sx={{ padding: '30px', backgroundColor: 'neutral.light' }}>{message}</Typography>
    </Box> : null
}